import React from "react";
import styled from "styled-components";
import { element } from "prop-types";

import __ from "src/utils/Translations";
import isUuid from "src/utils/jsHelpers/isUuid";
import { BusinessId } from "src/Components/DataTable/businessIdColumn";

const LINE_HEIGHT = 1.4;

const SimpleList = ({ children }) => <ul>{children}</ul>;

SimpleList.propTypes = {
  children: element.isRequired,
};

const CommaStyledList = styled.ul`
  display: inline;
  list-style: none;
  padding-left: 0px;
  margin-bottom: 0px;
  > li {
    display: inline;
    list-style: none;
    &::after {
      content: ", ";
    }
    &:last-child::after {
      content: "";
    }
  }
`;

const RowsLimitedStyledList = styled.ul`
  width: 100%;
  max-height: calc(${LINE_HEIGHT}em * var(--max-visible-rows, 1));
  line-height: ${LINE_HEIGHT}em;
  overflow-y: auto;
  word-wrap: break-word;
`;

const mapValueFromOptions = (
  options,
  key,
  optionValue = "value",
  optionLabel = "label",
  commaStyledList = false,
  maxVisibleRowsNumber,
  checkAsBoolean,
  hideUnmatched,
  rewriteUnmatchedValue
) => {
  const renderEditable = (cellInfo) => {
    const value = cellInfo.row[key];
    if (!Array.isArray(value)) {
      const matchedOption = options.find((option) =>
        checkAsBoolean
          ? option[optionValue] === !!value
          : option[optionValue] === value
      );
      if (hideUnmatched && !matchedOption) {
        return null;
      }
      if (!matchedOption && isUuid(value)) {
        return <BusinessId value={value} />;
      }

      if (!matchedOption && rewriteUnmatchedValue) {
        return (
          <div className="tableColumnStatus">
            {__(rewriteUnmatchedValue(value))}
          </div>
        );
      }

      const result = matchedOption ? matchedOption[optionLabel] : value;
      return <div className="tableColumnStatus">{__(result)}</div>;
    }

    let List;
    let listProps = {};

    switch (true) {
      case commaStyledList:
        List = CommaStyledList;
        break;
      case !!maxVisibleRowsNumber:
        List = RowsLimitedStyledList;
        listProps = {
          style: {
            "--max-visible-rows": maxVisibleRowsNumber,
          },
        };
        break;
      default:
        List = SimpleList;
        break;
    }

    return (
      <List {...listProps}>
        {value.map((elValue) => {
          const matchedOption = options.find(
            (option) => option[optionValue] === elValue
          );
          if (hideUnmatched && !matchedOption) {
            return null;
          }
          const result = matchedOption
            ? matchedOption[optionLabel]
            : `${__("Nieznany zasób")}: ${elValue}`;
          return <li key={elValue}>{result}</li>;
        })}
      </List>
    );
  };
  return renderEditable;
};

export default mapValueFromOptions;
